import { get, post } from './requests'

export const validateToken = token => get(['companies', 'validate-code', token], {})

export const validateHash = token => get(['companies', 'validate-org', token], {})

export const getInTouch = payload => post(['get-in-touch'], {}, payload)
